import { connect } from 'react-redux';
import { fetchRequestedIfNeeded as fetch } from 'common/ducks/payout';
import PaymentsTable from 'account/components/payout/payments_table';

const mapStateToProps = ({ payout }) => {
  return {
    type: 'requested',
    items: payout.requested
  };
}

export default connect(mapStateToProps, {
  fetch
})(PaymentsTable);



// WEBPACK FOOTER //
// ./account/containers/payout/requested_payments_table.js